import { useFormContext, SubmitFormButton, RadioField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { FormFooter } from '../styles';
const formFieldsContainerCss = "fuszw72";
const FormFieldsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(formFieldsContainerCss, props.className)} />;
});
export const FormContent = () => {
  const {
    handleReset
  } = useFormContext();
  return <>
      <FormFieldsContainer>
        <RadioField label={I18n.t('publisher.organization_settings.invitations.enabled_for.admins_and_group_admins')} name="invitation_permissions_enabled_for" value="group_admin" />
        <RadioField label={I18n.t('publisher.organization_settings.invitations.enabled_for.admins_only')} name="invitation_permissions_enabled_for" value="admin" />
      </FormFieldsContainer>
      <FormFooter>
        <Button decoration="secondary-outline" onClick={handleReset}>
          {I18n.t('publisher.action.cancel')}
        </Button>
        <SubmitFormButton>
          {I18n.t('publisher.action.save')}
        </SubmitFormButton>
      </FormFooter>
    </>;
};

require("./form_content.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./form_content.js");